export const GET_COMMISSION_STATEMENT = gql`
    query commissionStatement($id: Int!) {
        commissionStatement(id: $id) {
            commissionStatement {
                id
                statementDate
                status
                commissionItems {
                    legalName
                    commissionItems {
                        commissionItem {
                            merchantId
                            merchant
                            serviceActivationDate
                            setupAndAccessory
                            monthly
                            totalCommission
                        }
                    }
                    partner
                    partnerOfPartner
                }
            }
            selfBillingInvoice {
                id
                createdAt
                partner {
                    id
                    firstName
                    lastName
                    business {
                        businessType
                        legalName
                    }
                    billingContactInformation
                }
            }
            partnerName
            totalSetupAndAccessory
            totalMonthly
            totalCommission
            currency
            billingContactInformation {
                bci_email
                bci_ra_city
                bci_lastName
                bci_position
                bci_firstName
                bci_ra_country
                bci_ra_eircode
                bci_ra_countryCode
                bci_ra_addressLine1
                bci_ra_addressLine2
                bci_telephoneNumber
                bci_mobilePhoneNumber
            }
        }
    }
`;

export const GET_COMMISSION_STATEMENT_FILTERS = gql`
    query commissionStatementFilters($commissionType: String!) {
        commissionStatementFilters(commissionType: $commissionType) {
            ids {
                id
                commissionStatementId
            }
            partnerNames
        }
    }
`;

export const GET_FILTERED_COMMISSION_STATEMENTS = gql`
    query filteredCommissionStatements($filters: FiltersInput!, $page: PageFilters) {
        filteredCommissionStatements(filters: $filters, page: $page) {
            id
            commissionStatementId
            partnerName
            totalCommission
            statementDate
            billingCycle
            selfBillingInvoice {
                id
                sageInvoiceNumber
            }
            status
            commissionType
            currency
        }
    }
`;

export const GET_COMMISSION_STATEMENT_PDF = gql`
    query GetCommissionStatementPDF($statementId: Int!) {
        getCommissionStatementPDF(id: $statementId) {
            downloadLink
            createdAt
        }
    }
`;
